// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","455":"eaad5ed6"}[chunkId] + ".chunk.js";
};